import axios from 'axios'

export function normalizeInviteEmail (email) {
  return (email || '').trim().toLowerCase()
}

export function isEmailAmongMembers (email, members) {
  const normalized = normalizeInviteEmail(email)
  if (!normalized) return false
  return (members || []).some(m => normalizeInviteEmail(m.email) === normalized)
}

function listRows (payload) {
  if (Array.isArray(payload)) return payload
  if (payload && Array.isArray(payload.data)) return payload.data
  return []
}

export async function isEmailMemberOfGroups (context, email, groupIds) {
  const normalized = normalizeInviteEmail(email)
  if (!normalized || !groupIds || !groupIds.length) return false
  for (const groupId of groupIds) {
    const id = parseInt(groupId, 10)
    if (!id) continue
    try {
      const response = await axios.get(
        context.baseDomain + context.shopId + '/users.json',
        {
          params: {
            apikey: context.apiKey,
            filter_group: id,
            sSearch: normalized,
            page: 1,
            size: 20
          }
        }
      )
      if (listRows(response.data).some(user => normalizeInviteEmail(user.email) === normalized)) {
        return true
      }
    } catch (e) {}
  }
  return false
}
